// extracted by extract-css-chunks-webpack-plugin
module.exports = {"menu":"menu-2qZcMqdd","menu_w1000":"menu_w1000-3X7HjenU","logo":"logo-3dJ6cU4i","menu_r":"menu_r-34_y5940","active":"active--gEdhavB"};